<template lang="pug">
  span(:class="$style.mathQuill" ref="mathQuill") {{ value }}
</template>

<script>
  const MQ = window.MathQuill.getInterface(2)

  export default {
    props: {
      value: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        staticObject: null,
      }
    },

    watch: {
      value() {
        this.showText()
      },
    },

    mounted() {
      this.showText()
    },

    methods: {
      showText() {
        if (this.staticObject) {
          this.staticObject.revert()
          this.$nextTick(() => {
            MQ.StaticMath(this.$refs.mathQuill)
          })
        } else {
          this.staticObject = MQ.StaticMath(this.$refs.mathQuill)
        }
      },
    },
  }
</script>

<style module>
  .mathQuill {
    background-color: inherit;
    color: inherit;
    font-size: inherit;
  }
</style>